import options from './drag-drop.directive';

export default {
    selector: 'dtDrag',
    options
};
